import React from 'react';
import { Col, Row } from 'react-bootstrap';

export default function SummaryHeader({ settlement }) {
  return (
    <div className="info-box">
      <Row>
        <Col md={6} className="row">
          <Col className="col-6">
            <p className="info mb-0">
              <span>Nombre completo:</span>
            </p>
          </Col>
          <Col className="col-6">
            <p className="info">{settlement.employee?.fullName}</p>
          </Col>
        </Col>
        <Col md={6} className="row">
          <Col className="col-6">
            <p className="info mb-0">
              <span>Fecha de inicio de contrato:</span>
            </p>
          </Col>
          <Col className="col-6">
            <p className="info">{settlement.employee?.startDate}</p>
          </Col>
        </Col>

        <Col md={6} className="row">
          <Col className="col-6">
            <p className="info mb-0">
              <span>Identificación:</span>
            </p>
          </Col>
          <Col className="col-6">
            <p className="info">{settlement.employee?.nationalIdentification}</p>
          </Col>
        </Col>
        <Col md={6} className="row">
          <Col className="col-6">
            <p className="info mb-0">
              <span>Fecha de término de contrato:</span>
            </p>
          </Col>
          <Col className="col-6">
            <p className="info">{settlement?.endDate}</p>
          </Col>
        </Col>

        <Col md={6} className="row">
          <Col className="col-6">
            <p className="info mb-0">
              <span>Último cargo desempeñado:</span>
            </p>
          </Col>
          <Col className="col-6">
            <p className="info">{settlement.employee?.jobTitle}</p>
          </Col>
        </Col>
        <Col md={6} className="row">
          <Col className="col-6">
            <p className="info mb-0">
              <span>Tiempo trabajado:</span>
            </p>
          </Col>
          <Col className="col-6">
            <p className="info">{settlement.employee?.workedTime}</p>
          </Col>
        </Col>
        <Col md={6} className="row" />
        <Col md={6} className="row">
          <Col className="col-6">
            <p className="info mb-0">
              <span>Causal de término de contrato:</span>
            </p>
          </Col>
          <Col className="col-6">
            <p className="info">{settlement.terminationReason?.label}</p>
          </Col>
        </Col>
      </Row>
    </div>
  );
}
